<div *ngIf="!reset_password_token">
    <p>No existe un token para cambiar la contraseña.</p>
</div>
<div *ngIf="reset_password_token">
    <user-password-reset [reset_password_token]="reset_password_token"></user-password-reset>
</div>
